import * as tslib_1 from "tslib";
import { extend, sanitizeGuid, stringIsNullOrEmpty, getGUID } from "@pnp/common";
import { ClientSvcQueryable, MethodParams, setProperty, } from "@pnp/sp-clientsvc";
import { Labels } from "./labels";
import { TermSet, TermSets } from "./termsets";
var Terms = /** @class */ (function (_super) {
    tslib_1.__extends(Terms, _super);
    function Terms() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the terms in this collection
     */
    Terms.prototype.get = function () {
        var _this = this;
        return this.sendGetCollection(function (d) {
            if (!stringIsNullOrEmpty(d.Name)) {
                return _this.getByName(d.Name);
            }
            else if (!stringIsNullOrEmpty(d.Id)) {
                return _this.getById(d.Id);
            }
            throw Error("Could not find Name or Id in Terms.get(). You must include at least one of these in your select fields.");
        });
    };
    /**
     * Gets a term by id
     *
     * @param id The id of the term
     */
    Terms.prototype.getById = function (id) {
        var params = MethodParams.build()
            .string(sanitizeGuid(id));
        return this.getChild(Term, "GetById", params);
    };
    /**
     * Gets a term by name
     *
     * @param name Term name
     */
    Terms.prototype.getByName = function (name) {
        var params = MethodParams.build()
            .string(name);
        return this.getChild(Term, "GetByName", params);
    };
    return Terms;
}(ClientSvcQueryable));
export { Terms };
/**
 * Represents the operations available on a given term
 */
var Term = /** @class */ (function (_super) {
    tslib_1.__extends(Term, _super);
    function Term() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Term.prototype.addTerm = function (name, lcid, isAvailableForTagging, id) {
        var _this = this;
        if (isAvailableForTagging === void 0) { isAvailableForTagging = true; }
        if (id === void 0) { id = getGUID(); }
        var params = MethodParams.build()
            .string(name)
            .number(lcid)
            .string(sanitizeGuid(id));
        this._useCaching = false;
        return this.invokeMethod("CreateTerm", params, setProperty("IsAvailableForTagging", "Boolean", "" + isAvailableForTagging))
            .then(function (r) { return extend(_this.termSet.getTermById(r.Id), r); });
    };
    Object.defineProperty(Term.prototype, "terms", {
        get: function () {
            return this.getChildProperty(Terms, "Terms");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "labels", {
        get: function () {
            return new Labels(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "parent", {
        get: function () {
            return this.getChildProperty(Term, "Parent");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "pinSourceTermSet", {
        get: function () {
            return this.getChildProperty(TermSet, "PinSourceTermSet");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "reusedTerms", {
        get: function () {
            return this.getChildProperty(Terms, "ReusedTerms");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "sourceTerm", {
        get: function () {
            return this.getChildProperty(Term, "SourceTerm");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "termSet", {
        get: function () {
            return this.getChildProperty(TermSet, "TermSet");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Term.prototype, "termSets", {
        get: function () {
            return this.getChildProperty(TermSets, "TermSets");
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new label for this Term
     *
     * @param name label value
     * @param lcid language code
     * @param isDefault Is the default label
     */
    Term.prototype.createLabel = function (name, lcid, isDefault) {
        var _this = this;
        if (isDefault === void 0) { isDefault = false; }
        var params = MethodParams.build()
            .string(name)
            .number(lcid)
            .boolean(isDefault);
        this._useCaching = false;
        return this.invokeMethod("CreateLabel", params)
            .then(function (r) { return extend(_this.labels.getByValue(name), r); });
    };
    /**
     * Sets the deprecation flag on a term
     *
     * @param doDeprecate New value for the deprecation flag
     */
    Term.prototype.deprecate = function (doDeprecate) {
        var params = MethodParams.build().boolean(doDeprecate);
        return this.invokeNonQuery("Deprecate", params);
    };
    /**
     * Loads the term data
     */
    Term.prototype.get = function () {
        return this.sendGet(Term);
    };
    /**
     * Gets the appropriate description for a term
     *
     * @param lcid Language code
     */
    Term.prototype.getDescription = function (lcid) {
        var params = MethodParams.build().number(lcid);
        return this.invokeMethodAction("GetDescription", params);
    };
    /**
     * Sets the description
     *
     * @param description Term description
     * @param lcid Language code
     */
    Term.prototype.setDescription = function (description, lcid) {
        var params = MethodParams.build().string(description).number(lcid);
        return this.invokeNonQuery("SetDescription", params);
    };
    /**
     * Sets a custom property on this term
     *
     * @param name Property name
     * @param value Property value
     */
    Term.prototype.setLocalCustomProperty = function (name, value) {
        var params = MethodParams.build().string(name).string(value);
        return this.invokeNonQuery("SetLocalCustomProperty", params);
    };
    /**
     * Updates the specified properties of this term, not all properties can be updated
     *
     * @param properties Plain object representing the properties and new values to update
     */
    Term.prototype.update = function (properties) {
        return this.invokeUpdate(properties, Term);
    };
    /**
     * Deletes a this term
     *
     */
    Term.prototype.delete = function () {
        return this.invokeNonQuery("DeleteObject");
    };
    return Term;
}(ClientSvcQueryable));
export { Term };
//# sourceMappingURL=terms.js.map